applicationsSubNavbar.classy.controller({
    name: "AwardLettersModalController",
    inject: [
        "$scope", "item", "index", "$sce", "ApplicationService", "SchoolModelService",
        "AwardLetterTemplatesModelService", "AwardLetterModelService", "StandardCudFactory", "StandardModalCudFactory",
        "NoteModelService", "$modalInstance", "authServiceFactory", "ApplicationService", "ModelService",
        "StandardModalCudFactory"
    ],
    init: function() {
        this.$.ApplicationService = this.ApplicationService;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.$sce = this.$sce;
        this.$.modalCud = new this.StandardModalCudFactory(this.AwardLetterModelService,
            this.ApplicationService.getAwardData().app[0].applicationID, this.item, this, [], this.index,
            this.$modalInstance);
        this.$.templates = this.AwardLetterTemplatesModelService.get();
        if (Number(this.ApplicationService.getAwardData().awardGiven) > 0) {
            this.$.templatetype = 1;
        } else {
            this.$.templatetype = 0;
        }
        this.$.childIndex = 0;
        this.$.show = true;
        if (this.$.item.recordID === undefined) {
            if (this.$.templatetype === 1) {
                this.$.item = this.$.templates[0];
            } else {
                this.$.item = this.$.templates[1];
            }
            delete this.$.item.recordID;
        }
        this.$.applicationID = this.ApplicationService.getAwardData().app[0].applicationID;
        if (this.$.item.applicationID !== undefined) {
            this.$.recordID = this.$.item.recordID;
        }
        this.$.bname = "";
        this.$.btotal = 0;
        for (let i = 0; i < this.ApplicationService.getAwardData().applicants[0].budgets.length; i++) {
            if (this.ApplicationService.getAwardData().applicants[0].budgets[i].award > 0) {
                this.$.bname =  this.ApplicationService.getAwardData().applicants[this.$.childIndex].budgets[i].Account;
                this.$.btotal =  this.ApplicationService.getAwardData().applicants[this.$.childIndex].budgets[i].award;
            }
            if (this.$.bname !== "") {
                break;
            }
        }
        this.$.familyChoice = 0;
        this.autofill(0);
    },
    autofill: function(familyNo) {
        this.$.familyChoice = familyNo;
        let awardData = this.ApplicationService.getAwardData();
        let name = "";
        let total = "";
        for (let i = 0; i < awardData.applicants[0].budgets.length; i++) {
            if (awardData.applicants[0].budgets[i].award > 0) {
                name = awardData.applicants[this.$.childIndex].budgets[i].Account;
                total = awardData.applicants[this.$.childIndex].budgets[i].award;
            }
            if (name !== "") {
                break;
            }
        }
        let p1title = (awardData.family[familyNo].data[0].Fam_Gender === 0) ? "Ms." : "Mr.";
        let newtxt = this.$.item.text.replace(/ unselectable="on"/g, "")
            .replace(/SCHOOL_NAME/g, this.$.schoolinfo.School_Name)
            .replace(/NAME/g,
                this.authServiceFactory.getAuth().firstName + " " + this.authServiceFactory.getAuth().lastName)
            .replace(/{Application First Name}/g, awardData.applicants[this.$.childIndex].xApp_First)
            .replace(/{Application Last Name}/g, awardData.applicants[this.$.childIndex].xApp_Last)
            .replace(/{Family First Name - P1}/g, awardData.family[familyNo].data[0].Fam_Name_First)
            .replace(/{Family Last Name - P1}/g, awardData.family[familyNo].data[0].Fam_Name_Last)
            .replace(/{Grade}/g, awardData.applicants[this.$.childIndex].App_Division)
            .replace(/{AwardPercent}/g, parseInt((awardData.awardGiven / awardData.tuition) * 100) + "%")
            .replace(/{Tuition}/g, awardData.applicants[this.$.childIndex].App_Tuition)
            .replace(/<img src="\/img\/School Name.png">/g, this.$.schoolinfo.School_Name)
            .replace(/<img src="\/img\/Your Name.png">/g,
                this.authServiceFactory.getAuth().firstName + " " + this.authServiceFactory.getAuth().lastName)
            .replace(/<img src="\/img\/App First Name.png">/g, awardData.applicants[this.$.childIndex].xApp_First)
            .replace(/<img src="\/img\/App Last Name.png">/g, awardData.applicants[this.$.childIndex].xApp_Last)
            .replace(/<img src="\/img\/P1 First Name.png">/g, awardData.family[familyNo].data[0].Fam_Name_First)
            .replace(/<img src="\/img\/P1 Last Name.png">/g, awardData.family[familyNo].data[0].Fam_Name_Last)
            .replace(/<img src="\/img\/P1 Title.png">/g, p1title)
            .replace(/<img src="\/img\/P1 Address.png">/g, awardData.family[familyNo].data[0].Fam_Addy1 +
                "<br>" + awardData.family[familyNo].data[0].Fam_City + ", " +
                awardData.family[familyNo].data[0].Fam_State_Prov + "  " + awardData.family[familyNo].data[0].Fam_Zip)
            .replace(/<img src="\/img\/Grade.png">/g, awardData.applicants[this.$.childIndex].App_Division)
            .replace(/<img src="\/img\/AwardPercent.png">/g,
                parseInt((awardData.awardGiven / awardData.tuition) * 100) + "%")
            .replace(/<img src="\/img\/Tuition Due.png">/g,
                "$" + parseFloat(awardData.tuition - awardData.awardGiven).toFixed(2))
            .replace(/<img src="\/img\/Tuition.png">/g, "$" + awardData.applicants[this.$.childIndex].App_Tuition)
            .replace(/<img src="\/img\/Date.png">/g, moment().format("MMMM Do, YYYY"))
            .replace(/<img src="\/img\/Budget Name.png">/g, name)
            .replace(/<img src="\/img\/Budget Total.png">/g, total)
            .replace(/{Budget Name}/g, name)
            .replace(/{Budget Total}/g, total);

        if (awardData.app[0].Status_Consider === 1) {
            newtxt = newtxt
                .replace(/{Award}/g,
                    "$" + parseFloat(awardData.app[0].Award_Amount).toFixed(2))
                .replace(/<img src="\/img\/Award.png">/g,
                    "$" + parseInt(awardData.app[0].Award_Amount).toFixed(2));
        } else {
            newtxt = newtxt
                .replace(/{Award}/g,
                    "$" + parseInt(awardData.app[0].Award_Amount).toFixed(2))
                .replace(/<img src="\/img\/Award.png">/g,
                    "$" + parseInt(awardData.app[0].Award_Amount).toFixed(2));
        }

        if (awardData.family[familyNo].data[1] !== undefined) {
            let p2title = (awardData.family[0].data[1].Fam_Gender === 0) ? "Ms." : "Mr.";
            newtxt = newtxt.replace(/{Family First Name - P2}/g, awardData.family[familyNo].data[1].Fam_Name_First)
                .replace(/{Family Last Name - P2}/g, awardData.family[familyNo].data[1].Fam_Name_Last)
                .replace(/<img src="\/img\/P2 First Name.png">/g, awardData.family[familyNo].data[1].Fam_Name_First)
                .replace(/<img src="\/img\/P2 Last Name.png">/g, awardData.family[familyNo].data[1].Fam_Name_Last)
                .replace(/<img src="\/img\/P2 Title.png">/g, p2title)
                .replace(/<img src="\/img\/P2 Address.png">/g, awardData.family[familyNo].data[1].Fam_Addy1 +
                    "<br>" + awardData.family[familyNo].data[1].Fam_City +
                    ", " + awardData.family[familyNo].data[1].Fam_State_Prov +
                    "  " + awardData.family[familyNo].data[1].Fam_Zip);
        }

        if (awardData.family[1] !== undefined) {
            newtxt = newtxt.replace(/{Family 2 First Name - P1}/g, awardData.family[1].data[0].Fam_Name_First)
                .replace(/{Family 2 Last Name - P1}/g, awardData.family[1].data[0].Fam_Name_Last);
            if (awardData.family[1].data[1] !== undefined) {
                newtxt = newtxt.replace(/{Family 2 First Name - P2}/g, awardData.family[1].data[1].Fam_Name_First)
                    .replace(/{Family 2 Last Name - P2}/g, awardData.family[1].data[1].Fam_Name_Last);
            }
        }
        this.$.item.text = newtxt;
    },
    toggleChildren: function(dir) {
        if (dir === (-1)) {
            this.$.childIndex--;
            this.autofill(this.$.familyChoice);
        } else if (dir === 1) {
            if (this.$.childIndex < this.ApplicationService.getAwardData().applicants.length - 1) {
                this.$.childIndex++;
                this.autofill(this.$.familyChoice);
            }
        }
    },
    toggleLetter: function(template) {
        this.$.item = angular.copy(template);
        this.autofill(this.$.familyChoice);
    },
    toggleFamily: function(familyNo) {
        this.$.familyChoice = familyNo;
        let otherFamilyNo = 1 - familyNo; // gets opposite of familyNo (either 0 or 1)
        let familyData = this.ApplicationService.getAwardData().family[familyNo];
        let otherFamilyData = this.ApplicationService.getAwardData().family[otherFamilyNo];
        let regexp1 = new RegExp(otherFamilyData.data[0].Fam_Name_First, "g");
        let regexp2 = new RegExp(otherFamilyData.data[0].Fam_Name_Last, "g");
        let regexp3 = new RegExp(otherFamilyData.data[0].Fam_Addy1 + "<br>" + otherFamilyData.data[0].Fam_City +
            ", " + otherFamilyData.data[0].Fam_State_Prov + "  " + otherFamilyData.data[0].Fam_Zip, "g");
        this.$.item.text = this.$.item.text.replace(regexp1, familyData.data[0].Fam_Name_First)
            .replace(regexp2, familyData.data[0].Fam_Name_Last)
            .replace(regexp3, familyData.data[0].Fam_Addy1 + "<br>" + familyData.data[0].Fam_City +
                ", " + familyData.data[0].Fam_State_Prov + "  " + familyData.data[0].Fam_Zip);
        if (this.ApplicationService.getAwardData().family[familyNo].data.length > 1) {
            let regexp4 = new RegExp(otherFamilyData.data[1].Fam_Name_First, "g");
            let regexp5 = new RegExp(otherFamilyData.data[1].Fam_Name_Last, "g");
            this.$.item.text = this.$.item.text.replace(regexp4, familyData.data[1].Fam_Name_First)
                .replace(regexp5, familyData.data[1].Fam_Name_Last);
        }
    },
    clickToEdit: function() {
        this.$.show = !this.$.show;
    },
    insertChild: function(html, index) {
        let awardData = this.$.ApplicationService.getAwardData();
        this.$.childIndex = index;
        let html2 = html.replace(/{Application First Name}/g, awardData.applicants[this.$.childIndex].xApp_First)
            .replace(/{Application Last Name}/g, awardData.applicants[this.$.childIndex].xApp_Last)
            .replace(/{Family First Name - P1}/g, awardData.family[this.$.familyChoice].data[0].Fam_Name_First)
            .replace(/{Family Last Name - P1}/g, awardData.family[this.$.familyChoice].data[0].Fam_Name_Last)
            .replace(/{Grade}/g, awardData.applicants[this.$.childIndex].App_Division)
            .replace(/{Tuition}/g, "$" + awardData.applicants[this.$.childIndex].App_Tuition);
        if (awardData.app[0].Status_Consider === 1) {
            html2 = html2.replace(/{Award}/g, "$" + awardData.applicants[this.$.childIndex].ConsiderAward);
        } else {
            html2 = html2.replace(/{Award}/g, "$" + awardData.applicants[this.$.childIndex].ActAward);
        }
        $("#redactor").redactor("insert.html", html2);
        this.autofill(this.$.familyChoice);
    },
    insertBudget: function(html, index) {
        this.$.childIndex = index;
        $("#redactor").redactor("insert.html", String(html));
    },
    insertAll: function(html, length) {
        let place = "";
        let awardData = this.$.ApplicationService.getAwardData();
        if (html === "{Applicants}") {
            if (length === 2) {
                for (let i = 0; i < length; i++) {
                    if (i === length - 1) {
                        place += " and " + awardData.applicants[i].App_First;
                    } else {
                        place += awardData.applicants[i].App_First + " ";
                    }
                }
            } else {
                for (let j = 0; j < length; j++) {
                    if (j === length - 1) {
                        place += " and " + awardData.applicants[j].App_First;
                    } else {
                        place += awardData.applicants[j].App_First + ", ";
                    }
                }
            }
        } else if (html === "{Tuitions}") {
            place = "$" + awardData.tuition;
        } else if (html === "{AwardPercent}") {
            place = parseInt((awardData.awardGiven / awardData.tuition) * 100) + "%";
        } else if (html === "{Tuition Due}") {
            place = "$" + parseFloat(awardData.tuition - awardData.awardGiven).toFixed(2);
        } else {
            place = "$";
            let sum = 0;
            for (let k = 0; k < length; k++) {
                if (awardData.app[0].Status_Consider === 1) {
                    sum += parseInt(awardData.applicants[k].ConsiderAward);
                } else {
                    sum += parseInt(awardData.applicants[k].ActAward);
                }
            }
            place += sum;
        }
        $("#redactor").redactor("insert.html", place);
    },
    dismiss: function(index) {
        if (this.$.ApplicationService.getAwardData().awardLetters[index].recordID === 0
            || this.$.ApplicationService.getAwardData().awardLetters[index].recordID == undefined) {
            this.ApplicationService.getAwardData().awardLetters.pop();
        }
        this.$.item = this.$.oldtext;
        this.$.$modalInstance.dismiss("cancel");
    },
    saveClick: function() {
        let awardData = this.$.ApplicationService.getAwardData();
        $("#letterarea").wordExport(awardData.applicants[this.$.childIndex].App_Last + " Award Letter");
    },
    printClick: function() {
        let mywindow = window.open("", "", "height=400,width=800");
        mywindow.document.write("<html><head><title></title>");
        mywindow.document.write(`<style>
        @page { 
            size: auto; 
            margin-top: 2cm; 
            margin-bottom: 3cm; 
            font: arial; 
        } 
        body { 
            margin: 3.5cm 2cm 2.54cm 2.54cm 
        }
        </style>`);
        mywindow.document.write("</head><body >");
        mywindow.document.write($("#letterarea").html());
        mywindow.document.write("</body></html>");
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
        return true;
    },
    /*
     *     CUD SERVICES
    */
    startSaveProcess: function(scope, instance, form) {
        if (form.$valid) {
            instance.options.factor  = .3;
            let dt = new Date();
            let awardData = this.$.ApplicationService.getAwardData();
            this.$.item.date = dt.getDateMySqlFormatted();
            if (typeof this.$.item.applicationID !== "undefined") {
                this.AwardLetterModelService.put(awardData.app[0].applicationID, this.$.item, instance);
            } else {
                this.$.item.templateID = this.$.item.recordID;
                delete this.$.item.recordID;
                this.AwardLetterModelService.post(awardData.app[0].applicationID, this.$.item, instance).then((results) => {
                    this.$.item.id = results.data.id;
                    this.$.item.applicationID = awardData.app[0].applicationID;
                    awardData.awardLetters[awardData.awardLetters.length - 1] = this.$.item;
                });
            }
        } else {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, form) {
        this.$.modalCud.successSave(scope, instance, form);
        this.$.templates = this.AwardLetterTemplatesModelService.get();
    },
    successDelete: function(scope, instance, callback) {
        this.$.ApplicationService.getAwardData().awardLetters.splice(this.$.index, 1);
        this.$.$modalInstance.dismiss("cancel");
    }
    /*
     *     CUD SERVICES
    */
});